import * as yup from 'yup';

export const bookingConfirmationPageSchema = yup
	.object({
		hideBranding: yup.boolean().default(false),
	})
	.default({});
